var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react'; // tslint:disable-line
import { classNames } from '@shapeable/utils';
var cls = classNames('image-asset');
import styled from 'styled-components';
import { ImageEntity } from './image-entity';
import { useEnv } from '../hooks/use-env';
export var ImageAssetDefaultProps = {};
// -------- Styles -------->
// -------- Components -------->
var My = {
  Image: styled(ImageEntity)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])))
};
export var ImageAsset = function (props) {
  var className = props.className,
    entity = props.entity,
    rest = __rest(props, ["className", "entity"]);
  var env = useEnv();
  if (env.DEBUG_ENTITIES) {
    console.log("ImageAsset Entity:", entity);
  }
  return React.createElement(My.Image, __assign({
    entity: entity
  }, rest, {
    className: cls.name(className)
  }));
};
ImageAsset.defaultProps = ImageAssetDefaultProps;
ImageAsset.cls = cls;
var templateObject_1;